import styled from 'styled-components';
import { PRIMARY, HOVER_ITEM_COLOR, PRIMARY_DISABLED } from '../../utils/colors';
import Form from 'react-bootstrap/Form';

export const ProductDetailWrapper = styled.div`
  padding: 3rem 10rem;
  margin-top: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Figtree', sans-serif;

  @media (max-width: 800px) {
    padding: 2rem 1rem;
    margin-top: 70px;
  }
`

export const ProductImage = styled.img`
  width: 75%;
  max-width: 600px;
  height: auto;
  margin-bottom: 2rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  object-fit: cover;
`;

export const MiniProductImageList = styled.div`
  display: flex;
  flex-direction: column; 
  gap: 1rem; 
  align-items: center; 
  justify-content: center;

  @media (max-width: 1070px) {
    flex-direction: row;
    overflow-x: auto;
    gap: 0.5rem; 
    width: 100%;
    order: 2;
  }
`

export const MiniProductImage = styled.img`
  width: 60px;
  height: 60px;
  margin-right: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  object-fit: cover;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.1);
    cursor: pointer;
  }

  @media (max-width: 1070px) {
    &:hover {
      transform: none;
      cursor: pointer;
    }
  }

  @media (max-width: 600px) {
    width: 55px;
    height: 55px;
  }
`;

export const ProductTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
  font-family: 'FigtreeBold', sans-serif;
`;

export const LinkWrapper = styled.div`
  margin-bottom: 2rem;
  a {
    text-decoration: none;
    color: #007bff;
    font-weight: bold;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const SectionHeader = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  font-family: 'FigtreeBold', sans-serif;
`;

export const SectionContent = styled.p`
  font-size: 0.9rem;
  color: #555;
  margin: 0;
  font-family: 'Figtree', sans-serif;
`;

export const QuantityWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  font-family: 'Figtree', sans-serif;
`;

export const AddButton = styled.button`
  background-color: ${PRIMARY};
  color: white;
  padding: 10px 24px;
  border: none;
  border-radius: 10px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  font-family: 'FigtreeBold', sans-serif;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    background-color: ${HOVER_ITEM_COLOR};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }

  &:disabled {
    background-color: ${PRIMARY_DISABLED};
    cursor: not-allowed;
  }
`;

export const ProductDetailSpecificationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem 0;
  margin-top: 1rem;
`;

export const SpecificationRow = styled.p`
  border-bottom: 2px solid #ddd;
  margin: 0;
`

export const Select = styled(Form.Select)`
  width: 50%;
`